import { useState } from "react";
import { ScrollView } from "react-native-gesture-handler";
import useEditCoverGalleryPadding from "src/screens/(internal)/EditCoverGalleryModal/hooks/useEditCoverGalleryPadding";
import useEditCoverGalleryStore from "src/screens/(internal)/EditCoverGalleryModal/hooks/useEditCoverGalleryStore";
import EditCoverSelectedUnderline from "./components/EditCoverSelectedUnderline";
import EditCoverTabItem, { editCoverTabHorizontalPadding } from "./components/EditCoverTabItem";

const EditCoverTabSelector = () => {
	const { paddingHorizontal } = useEditCoverGalleryPadding();
	const configs = useEditCoverGalleryStore((state) => state.configs);
	const [widthLookup, setWidthLookup] = useState<Record<string, number>>({});

	return (
		<ScrollView
			horizontal
			showsHorizontalScrollIndicator={false}
			style={{
				width: "100%",
				maxHeight: 44,
				height: 44,
			}}
			contentContainerStyle={{
				justifyContent: "flex-start",
				alignItems: "center",
				paddingHorizontal: paddingHorizontal - editCoverTabHorizontalPadding,
			}}
		>
			{configs.map((config) => {
				return (
					<EditCoverTabItem
						key={config.itemKey}
						config={config}
						onWidthCalculated={(width) => {
							setWidthLookup((prev) => ({
								...prev,
								[config.itemKey]: width,
							}));
						}}
					/>
				);
			})}
			<EditCoverSelectedUnderline widthLookup={widthLookup} />
		</ScrollView>
	);
};
export default EditCoverTabSelector;
